import { FeatureFlagsAppConfig } from "./types";

export const portal: FeatureFlagsAppConfig = {
    local: {
        all: {
            highlights: true,
        },
        dica: {},
    },
    dev: {
        all: {
            highlights: true,
        },
        dica: {},
    },
    test: {
        all: {
            highlights: true,
        },
        dica: {},
    },
    accept: {
        all: {
            highlights: true,
        },
        dica: {},
    },
    staging: {
        all: {
            highlights: true,
        },
        dica: {},
    },
    demo: {
        all: {
            highlights: false,
        },
        dica: {},
    },
    prod: {
        all: {
            highlights: true,
        },
        dica: {},
    },
};
